import { useContext } from 'react';
import gtag from '../analytics/gtag';
import Icon from '../generic/Icon';
import { TrackingContext } from '../generic/TrackingContext';
import type { FacetValue } from '../model/Facets';
import ProductIcon from '../product/ProductIcon';
import preventDefault from '../utils/preventDefault';
import { useAsyncAction } from '../utils/useAsyncAction';
import * as style from './FacetValue.module.css';

interface Props {
    value: FacetValue;
    onFacetValueSelect(query: string): Promise<void> | void;
}

export default function FacetValue({ value, onFacetValueSelect }: Props) {
    const { filter_type } = useContext(TrackingContext);

    const [onClick, isLoading] = useAsyncAction(async (value: FacetValue) => {
        gtag('event', value.selected ? 'filter_remove' : 'filter', {
            filter_type,
            filter_value: value.name,
        });
        await onFacetValueSelect(value.query);
    });

    return (
        <a href={value.href} className={style.facetValue} onClick={preventDefault(() => onClick(value))} aria-busy={isLoading}>
            {!!value.iconImageClass && <ProductIcon icon={value.iconImageClass} />}
            <span className={style.name}>{value.name}</span>
            {!!value.count && (isLoading ? <Icon className="spinner-bg" /> : <span className={style.count}>{value.count}</span>)}
            {value.description && <p className={style.description}>{value.description}</p>}
        </a>
    );
}
